import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, HostListener, Inject, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, fromEvent, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { EmailSendService } from 'src/app/services/email-send.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SendEmailService } from 'src/app/services/send-email.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { environment } from 'src/environments/environment';

import { TemplateConfirmPopupComponent } from './template-confirm-popup/template-confirm-popup.component';
import { TemplateServiceService } from 'src/app/services/template-service.service';
import { DocEditorComponent } from 'src/app/shared/doc-editor/doc-editor.component';
import { EmailHtmlNormalizerService } from 'src/app/services/email-html-normalizer.service';
import { LeadService } from 'src/app/services/lead.service';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { NextBestActionService, NextBestActionResult } from 'src/app/services/next-best-action.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { UserMailConfigService } from 'src/app/services/user-mail-config.service';

@Component({
  selector: 'calsoft-email-popup-component',
  templateUrl: './email-popup-component.component.html',
  styleUrls: ['./email-popup-component.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailPopupComponentComponent implements OnInit, AfterViewInit, OnDestroy {


  url = '';
  sanitizedUrl = '';


  data: any;

  enableSalesAssistant: any;
  useIndividualMail: any = 0;

  constructor(private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private sendEmailService: SendEmailService,
    public dialog: MatDialog,
    private emailSendService: EmailSendService,
    private templatesService: TemplateServiceService,
    private emailHtmlNormalizer: EmailHtmlNormalizerService,
    private dialogRef: MatDialogRef<EmailPopupComponentComponent>,
    @Inject(MAT_DIALOG_DATA) data, private router: Router,
    private leadService: LeadService,
    private crmNoteService: CrmNoteService,
    private nbaService: NextBestActionService,
    private ecryptService: EcryptServiceService,
    private userMailConfigService: UserMailConfigService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.data = data;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  firstFormGroup: UntypedFormGroup;

  text: string;

  type: any = 1;

  // AI Email Generator Properties
  leadDetails: any = null;
  recentNotes: any[] = [];
  nbaRecommendation: NextBestActionResult | null = null;
  aiLoading = false;
  aiSuggestedSubject = '';
  aiSuggestedBody = '';
  customInstructions = '';
  selectedEmailType: 'followup' | 'proposal' | 'stalled' | 'nurture' | 'renewal' = 'followup';
  strategicContext = '';

  ngOnInit() {


    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['enableSalesAssistant'] != undefined) {
            this.enableSalesAssistant = data['enableSalesAssistant'];
          } else {
            this.enableSalesAssistant = 0;
          }

          this.useIndividualMail = data['useIndividualMail'];
        }

      } catch (error) {

      }


    }

    this.initForm();

    try {
      this.firstFormGroup.get('body')?.valueChanges.subscribe((v) => {
      });
    } catch (e) { }

    this.getAllTemplatesDropDown();

    this.templateFilter();

    this.getAllAttributeList();

    this.attributeYFilter();

    this.text = "Send";

    console.log(this.data, "data");


    this.firstFormGroup.patchValue({
      email: this.data.email,
      subject: this.data.subject,
      body: this.data.body,
      clientName: this.data.name,
      leadId: this.data.leadId,
      type: this.data.type,
      messageId: this.data.messageId,
      threadId: this.data.threadId,
      cc: this.data.cc,
      bcc: this.data.bcc,
      fromEmail: this.data.fromEmail,
      fromEmailId: this.data.fromEmailId
    });

    if (this.data.cc) {
      this.ccEmails = this.data.cc.split(',').map(e => e.trim()).filter(e => e);
    }
    if (this.data.bcc) {
      this.bccEmails = this.data.bcc.split(',').map(e => e.trim()).filter(e => e);
    }

    this.type = this.data.type;

    if (this.data && this.data.leadId) {
      this.fetchCrmContext(this.data.leadId);
    }

    this.getAllUserMailConfig();

    this.typeYFilter();
  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      email: ['', [Validators.email]],
      cc: [''],
      bcc: [''],
      subject: [''],
      body: [''],
      clientName: [''],
      leadId: [''],
      operationType: [''],
      attachment: [''],
      template: [''],
      type: [''],
      fieldControl: [''],
      messageId: [''],
      threadId: [''],
      fromEmail: [''],
      fromEmailId: ['', this.useIndividualMail == 1 ? Validators.required : null],
      attachments: this._formBuilder.array([
        //this.attachment()
      ]),

    });
  }

  attachment(): UntypedFormGroup {
    return this._formBuilder.group({
      image: [''],
      fullUrl: [''],
      value: [''],
      fileType: ['']
    });
  }


  sendEmail() {

    if (this.text == 'Send' && this.firstFormGroup.valid) {
      this.text = "Processing";

      const formValue = this.firstFormGroup.value;

      formValue.attachment = formValue.attachments.map(a => a.fullUrl).join(",");

      if (formValue.attachments && formValue.attachments.length > 0) {
        formValue.attachment = formValue.attachments
          .map(a => a.fullUrl)
          .filter(url => url)
          .join(',');
      } else {
        formValue.attachment = '';
      }

      delete formValue.attachments;

      formValue.operationType = "New";

      formValue.id = 0;
      formValue.messageId = this.firstFormGroup.get('messageId')?.value;
      formValue.threadId = this.firstFormGroup.get('threadId')?.value;
      let htmlTexEditor = (this.firstFormGroup.value.body || '').toString();
      try {
        htmlTexEditor = this.emailHtmlNormalizer.normalizeHtmlForEmail(htmlTexEditor);
      } catch (e) {
        // ignore
      }


      htmlTexEditor = htmlTexEditor.replace('amp;', '');

      this.firstFormGroup.get('body')?.setValue(htmlTexEditor);

      formValue.body = htmlTexEditor;

      this.emailSendService.addOrEmailSend(formValue).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.text = "Send";
            this.dialog.closeAll();
          }
          else {
            this.text = "Send";
            this.dialog.closeAll();
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => {
          this.dialog.closeAll();
          this.text = "Send"
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  // HTML normalization is now handled by EmailHtmlNormalizerService

  close() {
    try {
      const raw = (this.firstFormGroup?.get('body')?.value || '').toString();
      let normalized = this.emailHtmlNormalizer.normalizeHtmlForEmail(raw);

      // Remove amp; encoding artifact
      normalized = normalized.replace('amp;', '');

      this.firstFormGroup?.get('body')?.setValue(normalized, { emitEvent: false });
    } catch (e) {
      // ignore
    }
    // this.dialog.closeAll();
    this.dialogRef.close();
  }

  separatorKeysCodes: number[] = [ENTER, COMMA];
  ccEmails: string[] = [];

  addCcEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = (event.value || '').trim();

    if (value) {
      // Handle multiple emails typed together like: "a@example.com, b@example.com"
      const emails = value.split(',').map(email => email.trim()).filter(e => e);

      emails.forEach(email => {
        if (this.validateEmail(email) && !this.ccEmails.includes(email)) {
          this.ccEmails.push(email);
        }
      });

      this.updateCcControl();
    }

    // Clear input
    if (input) {
      input.value = '';
    }
  }

  removeCcEmail(email: string): void {
    const index = this.ccEmails.indexOf(email);
    if (index >= 0) {
      this.ccEmails.splice(index, 1);
      this.updateCcControl();
    }
  }

  updateCcControl(): void {
    const ccString = this.ccEmails.join(',');
    this.firstFormGroup.get('cc')?.setValue(ccString);
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  bccEmails: string[] = [];

  addBccEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = (event.value || '').trim();

    if (value) {
      const emails = value.split(',').map(e => e.trim()).filter(e => e);
      emails.forEach(email => {
        if (this.validateEmail(email) && !this.bccEmails.includes(email)) {
          this.bccEmails.push(email);
        }
      });
      this.updateBccControl();
    }

    if (input) input.value = '';
  }

  removeBccEmail(email: string): void {
    const index = this.bccEmails.indexOf(email);
    if (index >= 0) {
      this.bccEmails.splice(index, 1);
      this.updateBccControl();
    }
  }

  updateBccControl(): void {
    this.firstFormGroup.get('bcc')?.setValue(this.bccEmails.join(','));

    console.log(this.firstFormGroup);

  }

  ngOnDestroy() {
    // unsubscribe any container scroll listener
    if ((this as any).pageScrollSub) {
      try {
        (this as any).pageScrollSub.unsubscribe();
      } catch (e) {
        // ignore
      }
      (this as any).pageScrollSub = null;
    }

    // complete the subject used for takeUntil
    try {
      this._onDestroy.next();
      this._onDestroy.complete();
    } catch (e) {
      // ignore
    }

    // calsoft-doc-editor manages its own teardown
  }




  public serverPath = environment.commonImageApi + 'gmail/';



  getValueNew(event, index) {

    let cid = localStorage.getItem(Constant.enterPriseKey);

    const documentsAttachment = this.firstFormGroup.get('attachments') as UntypedFormArray;

    const documentVales = documentsAttachment.at(index) as UntypedFormGroup;

    console.log("documentVales", documentVales);

    let imageFile = this.serverPath + event;

    documentVales.get('image').setValue(event);


    imageFile += "&cid=" + cid

    console.log(imageFile);


    documentVales.get('fullUrl').setValue(imageFile);


  }


  getResultBanner(event) {

    let cid = localStorage.getItem(Constant.enterPriseKey);

    var arrayControl = this.firstFormGroup.get('attachments') as UntypedFormArray;

    event.productEntityMediaGallery.forEach(element => {

      console.log("fileName", element['fileName']);

      const fileExtension = element['fileName'].split('.').pop()?.toLowerCase();

      console.log("fileExtension", fileExtension);


      let imageFile = this.serverPath + element['fileName'];

      imageFile += "&cid=" + cid;

      arrayControl.push(this._formBuilder.group({
        image: new UntypedFormControl(element['fileName']),
        fullUrl: new UntypedFormControl(imageFile),
        fileType: new UntypedFormControl(fileExtension)
      })

      )
    });

    console.log(this.firstFormGroup);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });

  }


  removeImageOption(index: number): void {
    const imagesFormArray = this.firstFormGroup.get('attachments') as FormArray;
    if (imagesFormArray) {
      imagesFormArray.removeAt(index);
    }
  }


  //template

  templateList: any;

  filteredTemplateList: any;

  templateFilterControl: UntypedFormControl = new UntypedFormControl();

  protected _onDestroy = new Subject<void>();

  private pageScrollSub: Subscription | null = null;

  ngAfterViewInit(): void {
    // If the scrollable area is the inner container (dialog content), listen to its scroll
    try {
      if (this.pageContainer && this.pageContainer.nativeElement) {
        this.pageScrollSub = fromEvent(this.pageContainer.nativeElement, 'scroll').subscribe((evt: Event) => {
          const el = this.pageContainer.nativeElement as HTMLElement;
          this.isShowScrollTop = (el.scrollTop || 0) > 20; // show after 20px scroll inside container
        });
      }
    } catch (e) {
      // ignore if ViewChild not available or fromEvent fails
    }
  }


  getAllTemplatesDropDown() {
    this.templatesService.getAllEmailSendDropDownPrimary().subscribe(
      res => {
        this.templateList = res;

        this.filteredTemplateList = this.templateList;

      },
      error => {

      }
    )
  }


  templateFilter() {
    this.templateFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.templatesFilter();
      });
  }


  protected templatesFilter() {
    if (!this.templateList) {
      return;
    }

    let search = this.templateFilterControl.value;
    if (!search) {
      this.filteredTemplateList = this.templateList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTemplateList = this.templateList.filter(templateName => templateName['templateName'].toLowerCase().indexOf(search) > -1)
  }

  onTemplateSelect(eventOrTemplate: any, templateObj?: any) {
    let event: any = null;
    let templateName: any = null;

    if (eventOrTemplate && eventOrTemplate.source !== undefined) {
      event = eventOrTemplate;
      templateName = templateObj;
    } else {
      templateName = eventOrTemplate;
    }

    // mat-option emits onSelectionChange for both selection and deselection.
    // Only proceed if option is selected (ignore deselection).
    if (event && event.source && !event.source.selected) {
      return;
    }

    let templateJson = templateName ? templateName.body : null;

    if (templateJson) {
      const dialogRef = this.dialog.open(TemplateConfirmPopupComponent);

      dialogRef.afterClosed().subscribe(result => {
        if (result) {

          // Normalize selected template HTML for preview:
          // - convert <p> to <div> to avoid email-client paragraph gaps
          // - preserve <br> line breaks (normalizeHtmlForEmail keeps/creates <br> as needed)
          try {
            templateJson = this.emailHtmlNormalizer.normalizeHtmlForEmail((templateJson || '').toString());
          } catch (e) {
            // ignore
          }

          // Remove amp; encoding artifact
          templateJson = templateJson.replace('amp;', '');

          const patchObj: any = {
            body: templateJson
          };

          const templateSubject = templateName?.subject || templateName?.subjectLine || templateName?.templateSubject;
          if (templateSubject) {
            patchObj.subject = templateSubject;
          }

          this.firstFormGroup.patchValue(patchObj);

          // If the selected template contains attachments, parse and add them
          try {
            const attachmentsControl = this.firstFormGroup.get('attachments') as UntypedFormArray;

            // clear any existing attachments
            if (attachmentsControl && attachmentsControl.length) {
              while (attachmentsControl.length !== 0) {
                attachmentsControl.removeAt(0);
              }
            }

            if (templateName.attachment) {
              templateName.attachment.split(',')
                .map((v: string) => v.trim())
                .filter((v: string) => v !== '')
                .forEach((url: string) => {
                  const originalName = url.split('/').pop();
                  let fileExtension = originalName?.split('.').pop()?.toLowerCase() || '';

                  if (fileExtension.includes('&cid=')) {
                    fileExtension = fileExtension.split('&cid=')[0];
                  }

                  attachmentsControl.push(
                    this._formBuilder.group({
                      image: originalName,
                      fullUrl: url.trim(),
                      fileType: fileExtension
                    })
                  );
                });
            }
          } catch (e) {
            // ignore attachment parsing errors
          }

          // IMPORTANT:
          // - templateJson is HTML markup
          // - externalInsertText inserts as *plain text* (and escapes HTML)
          // So do NOT use externalInsertText for templates.
          // Patching the reactive form control will flow through the editor's CVA and render HTML.
        }
      });
    }
  }


  //attribute
  attributeList: any = [];
  attributeTypeList: any = [];
  filteredAttributeTypeList: any = [];
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllAttributeList() {

    this.templatesService.getDropDown(9).subscribe(
      data => {
        this.attributeList = data;
        this.attributeTypeList = data;
        this.filteredAttributeTypeList = this.attributeTypeList;

      }
    )

  }

  attributeYFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }

  protected attributeFilter() {
    if (!this.attributeList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeTypeList = this.attributeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeTypeList = this.attributeTypeList.filter(Attribute => Attribute['frontendLabel'].toLowerCase().indexOf(search) > -1)
  }

  selectedField: any = null;

  fieldControl = new FormControl();

  @ViewChild('composeEditor') private composeDocEditor?: DocEditorComponent;

  // Used to push one-shot inserts into <calsoft-doc-editor> via @Input().
  composeEditorInsertText: string | null = null;
  composeEditorInsertToken = 0;

  private lastInsertTarget: 'subject' | 'body' = 'body';

  @HostListener('document:focusin', ['$event'])
  onDocumentFocusIn(ev: FocusEvent) {
    try {
      const t = ev.target as HTMLElement | null;
      if (!t) return;

      // Subject input
      if (t.tagName === 'INPUT' && (t.getAttribute('formcontrolname') || '').toLowerCase() === 'subject') {
        this.lastInsertTarget = 'subject';
        return;
      }

      // Body editor (contenteditable)
      if (t.closest && t.closest('calsoft-doc-editor .compose-editor')) {
        this.lastInsertTarget = 'body';
        return;
      }
    } catch (e) { }
  }


  insertField(event: any, opt: any): void {
    // MatOption selection events vary across versions; avoid relying on private/internal flags.
    // If we got here and opt.value exists, perform the insertion.
    try {
      if (!opt?.value) {
        return;
      }

      const placeholder = `{{${opt.value}}}`;

      // mat-select steals focus, so rely on last focused target (subject vs body).
      let insertedIntoInput = false;
      try {
        if (this.lastInsertTarget === 'subject') {
          // Find the subject input in the dialog and insert at its caret.
          const container = document.querySelector('mat-dialog-container') as HTMLElement | null;
          const el = (container
            ? (container.querySelector('input[formcontrolname="subject"]') as HTMLInputElement | null)
            : (document.querySelector('input[formcontrolname="subject"]') as HTMLInputElement | null));
          if (!el) throw new Error('Subject input not found');

          el.focus();
          const start = (el.selectionStart ?? el.value.length) as number;
          const end = (el.selectionEnd ?? el.value.length) as number;
          const before = el.value.slice(0, start);
          const after = el.value.slice(end);
          const next = `${before}${placeholder}${after}`;
          el.value = next;
          // Place caret after inserted placeholder
          try {
            const pos = start + placeholder.length;
            el.setSelectionRange(pos, pos);
          } catch (e) { }
          // Update reactive form control if this input is bound into the form.
          try {
            this.firstFormGroup.get('subject')?.setValue(next, { emitEvent: true });
            this.firstFormGroup.get('subject')?.markAsDirty();
            this.firstFormGroup.get('subject')?.markAsTouched();
          } catch (e) { }
          insertedIntoInput = true;
        }
      } catch (e) { }

      // Otherwise insert into body editor via DocEditor @Input channel.
      if (!insertedIntoInput) {
        try {
          if (this.composeDocEditor) {
            this.composeDocEditor.insertTextAtCursor(placeholder);
          } else {
            this.composeEditorInsertText = `${placeholder}`;
            this.composeEditorInsertToken++;
          }
        } catch (e) {
          this.composeEditorInsertText = `${placeholder}`;
          this.composeEditorInsertToken++;
        }
      }

      // NOTE: Only use ONE insertion path to avoid duplicates.
      // We drive insertion via the DocEditor @Input channel and token.
      // DocEditor will insert and propagate the final HTML through CVA/valueChange.

      // Clear selection in dropdown so user can pick again.
      try {
        this.firstFormGroup.get('fieldControl')?.setValue(null, { emitEvent: false });
        setTimeout(() => {
          this.firstFormGroup.get('fieldControl')?.reset();
        });
      } catch (e) { }
    } catch (e) {
      // ignore
    }
  }




  insert: any = [
    { "value": "email", "viewValue": "Email" },
    { "value": "phoneNumber", "viewValue": "Phone Number" },
    { "value": "name", "viewValue": "Name" },
    { "value": "ownerEmail", "viewValue": "Lead Owner Email" },
    { "value": "City", "viewValue": "City" },
    { "value": "Country", "viewValue": "Country" },
    { "value": "State", "viewValue": "State" },
    { "value": "tagName", "viewValue": "Tag Name" },
    { "value": "company", "viewValue": "Company" },
  ]

  @ViewChild('pageContainer') pageContainer!: ElementRef;
  isShowScrollTop = false;
  @HostListener('window:scroll')
  onWindowScroll() {
    this.isShowScrollTop = window.scrollY > 20;
  }

  scrollToTop() {
    this.pageContainer.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  fetchCrmContext(leadId: number) {
    this.aiLoading = true;

    // Fetch Lead Details
    this.leadService.getLeadById(leadId).subscribe({
      next: (lead: any) => {
        this.leadDetails = lead;
        this.updateStrategicContext();
        this.generateDraft();
      },
      error: () => {
        this.aiLoading = false;
      }
    });

    // Fetch Recent Notes
    this.crmNoteService.getAllNoteByLeadId(leadId, 1).subscribe({
      next: (notes: any) => {
        this.recentNotes = Array.isArray(notes) ? notes : (notes?.content || []);
        this.updateStrategicContext();
        this.generateDraft();
      },
      error: () => { }
    });

    // Fetch Strategy Recommendation
    this.nbaService.getLatest(leadId).subscribe({
      next: (recommendation) => {
        this.nbaRecommendation = recommendation;
        this.updateStrategicContext();
        this.generateDraft();
      },
      error: () => { }
    });
  }

  updateStrategicContext() {
    let context = '';
    const stage = this.leadDetails?.leadStatusName || this.nbaRecommendation?.leadStage || 'New Contact';
    const score = this.leadDetails?.leadScoreCategory || this.nbaRecommendation?.leadScoreCategory || 'NEW';
    context += `Pipeline Stage: ${stage} | Priority: ${score} Lead\n`;

    if (this.recentNotes && this.recentNotes.length > 0) {
      const latestNoteText = this.recentNotes[0]?.noteName || '';
      context += `Last Note: "${latestNoteText.substring(0, 80)}${latestNoteText.length > 80 ? '...' : ''}"\n`;

      const containsPricing = this.recentNotes.some(n => (n.noteName || '').toLowerCase().includes('pricing') || (n.noteName || '').toLowerCase().includes('cost'));
      const containsDemo = this.recentNotes.some(n => (n.noteName || '').toLowerCase().includes('demo') || (n.noteName || '').toLowerCase().includes('call'));

      if (containsPricing) {
        context += `💡 Signal: Pricing request identified.\n`;
      }
      if (containsDemo) {
        context += `💡 Signal: Direct conversation history logged.\n`;
      }
    } else {
      context += `⚠️ Signal: Initial outreach required (no call notes).\n`;
    }

    if (this.nbaRecommendation) {
      context += `🎯 Recommendation: ${this.nbaRecommendation.recommendedAction || this.nbaRecommendation.actionType}`;
    } else {
      context += `🎯 Recommendation: Follow-up call or check-in email`;
    }

    this.strategicContext = context;
    this.aiLoading = false;
  }

  selectEmailType(type: 'followup' | 'proposal' | 'stalled' | 'nurture' | 'renewal') {
    this.selectedEmailType = type;
    this.generateDraft();
  }

  generateDraft() {
    const clientName = this.data.name || this.leadDetails?.name || 'there';
    const company = this.leadDetails?.company || 'your team';
    const ownerEmail = this.leadDetails?.ownerEmail || 'us';
    const ownerName = this.leadDetails?.ownerName || 'Sales Representative';

    let subject = '';
    let body = '';

    switch (this.selectedEmailType) {
      case 'followup':
        subject = `Great connecting with you, ${clientName}!`;
        body = `<div>Hi ${clientName},</div><br/>` +
          `<div>It was wonderful speaking with you. I wanted to follow up on our discussion and confirm next steps. I'm excited about the possibility of partnering with ${company} to streamline your sales workflows.</div><br/>` +
          `<div>As discussed, I have attached our case studies and product overviews for your review. Please let me know if you have any questions or if you would like to schedule a quick 15-minute call next week to dive deeper.</div><br/>` +
          `<div>Looking forward to hearing from you!</div><br/>` +
          `<div>Best regards,</div>` +
          `<div><strong>${ownerName}</strong></div>` +
          `<div>${ownerEmail}</div>`;
        break;

      case 'proposal':
        const pricingText = this.recentNotes.some(n => (n.noteName || '').toLowerCase().includes('pricing')) ? 'custom pricing structure based on your specific scaling needs' : 'standard commercial breakdown';
        subject = `Proposal & Custom Pricing Details for ${company}`;
        body = `<div>Hi ${clientName},</div><br/>` +
          `<div>Thank you for your interest in our solutions. Based on our latest conversation, I have put together a ${pricingText}.</div><br/>` +
          `<div>We are committed to delivering maximum ROI for ${company}. Here is a high-level summary of the tailored package we discussed:</div>` +
          `<ul>` +
          `  <li><strong>Professional Tier License</strong>: Access to all advanced sales pipeline automations and AI strategists.</li>` +
          `  <li><strong>Premium Support & Onboarding</strong>: Dedicated Customer Success Manager for seamless CRM integration.</li>` +
          `  <li><strong>Flexible Commercials</strong>: Options tailored to your monthly or annual budgeting goals.</li>` +
          `</ul><br/>` +
          `<div>I have attached the full PDF proposal containing complete line-item details. Let me know which pricing tier aligns best with your goals, and we can initiate setup!</div><br/>` +
          `<div>Best regards,</div>` +
          `<div><strong>${ownerName}</strong></div>` +
          `<div>${ownerEmail}</div>`;
        break;

      case 'stalled':
        subject = `Checking in - ${company} & CRM Automation`;
        body = `<div>Hi ${clientName},</div><br/>` +
          `<div>I hope you are having a productive week.</div><br/>` +
          `<div>I am reaching out to check in on our previous discussion regarding CRM automation. I know things get incredibly busy, so I wanted to see if there are any new updates, or if your timeline has shifted.</div><br/>` +
          `<div>If you're still looking to optimize your sales pipelines and double rep output this quarter, I'd love to reconnect. Would you have 10 minutes for a brief touchpoint next Tuesday or Wednesday?</div><br/>` +
          `<div>Best regards,</div>` +
          `<div><strong>${ownerName}</strong></div>` +
          `<div>${ownerEmail}</div>`;
        break;

      case 'nurture':
        subject = `New Industry Insights for ${company}`;
        body = `<div>Hi ${clientName},</div><br/>` +
          `<div>I was recently reading through our latest case study detailing how high-growth sales teams scaled their outbound personalization by 4x while maintaining high response rates, and immediately thought of ${company}.</div><br/>` +
          `<div>I've attached a copy of the case study here. I hope you find the playbooks and insights on page 5 particularly valuable for your outbound team.</div><br/>` +
          `<div>If you would ever like to benchmark your current sales tech stack or brainstorm outbound optimization strategies, I am always here to share best practices.</div><br/>` +
          `<div>Have a fantastic day!</div><br/>` +
          `<div>Best regards,</div>` +
          `<div><strong>${ownerName}</strong></div>` +
          `<div>${ownerEmail}</div>`;
        break;

      case 'renewal':
        subject = `Partner Success & Upcoming Account Renewal for ${company}`;
        body = `<div>Hi ${clientName},</div><br/>` +
          `<div>I hope you are doing well. It has been a pleasure working together over the past year to drive sales performance at ${company}.</div><br/>` +
          `<div>Your annual subscription renewal is coming up next month. I want to ensure we set you up for even greater success in the coming year. I have prepared an account performance summary showcasing your team's CRM usage, feature adoption rates, and key milestone achievements.</div><br/>` +
          `<div>Let's schedule a brief 15-minute sync next week to review this summary, discuss renewal terms, and walk through some of our exciting new AI features that are now available in your tier.</div><br/>` +
          `<div>Best regards,</div>` +
          `<div><strong>${ownerName}</strong></div>` +
          `<div>${ownerEmail}</div>`;
        break;
    }

    // Apply custom instructions if provided
    if (this.customInstructions && this.customInstructions.trim()) {
      const instr = this.customInstructions.trim().toLowerCase();

      if (instr.includes('discount') || instr.includes('%')) {
        body = body.replace('Flexible Commercials', 'Special Outbound Promo (15% Off)');
        body = body.replace(/setup!<\/div>/g, 'setup, including a limited-time 15% discount on your first 3 months!</div>');
      }
      if (instr.includes('tuesday') || instr.includes('sync') || instr.includes('schedule') || instr.includes('call')) {
        body = body.replace(/next week/g, 'this coming Tuesday at 2 PM');
      }
      if (instr.includes('formal') || instr.includes('polite')) {
        body = body.replace(/Hi /g, 'Dear ').replace(/Great connecting/g, 'Professional Follow-Up');
      }
      if (instr.includes('short') || instr.includes('concise')) {
        body = body.replace(/I am reaching out to check in on our previous discussion.*shifted\./i, 'I wanted to check if you had a chance to review our previous discussion.');
      }

      body += `<br/><br/><em>* Draft adjusted dynamically based on custom instructions: "${this.customInstructions}"</em>`;
    }

    this.aiSuggestedSubject = subject;
    this.aiSuggestedBody = body;
  }

  applyDraftToForm() {
    this.firstFormGroup.patchValue({
      subject: this.aiSuggestedSubject,
      body: this.aiSuggestedBody
    });
    this.snackBar.open('AI Draft successfully inserted into your editor!', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 3000
    });
  }

  copyDraftToClipboard() {
    const textContent = `Subject: ${this.aiSuggestedSubject}\n\n${this.aiSuggestedBody.replace(/<[^>]*>/g, '')}`;
    navigator.clipboard.writeText(textContent).then(() => {
      this.snackBar.open('Copied to clipboard!', '×', {
        panelClass: 'success',
        verticalPosition: 'bottom',
        duration: 2000
      });
    });
  }

  getMailtoUrl(client: 'gmail' | 'outlook'): string {
    const email = this.firstFormGroup.get('email')?.value || '';
    const subject = encodeURIComponent(this.aiSuggestedSubject);
    const plainBody = encodeURIComponent(this.aiSuggestedBody.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' '));

    if (client === 'gmail') {
      return `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${plainBody}`;
    } else {
      return `mailto:${email}?subject=${subject}&body=${plainBody}`;
    }
  }


  filtereddropdownTypeList: any;
  dropdownTypeList: any;
  dropdownList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllUserMailConfig() {

    this.userMailConfigService.getAllUserMailConfig().subscribe(res => {
      this.dropdownList = res;
      this.dropdownTypeList = res;
      this.filtereddropdownTypeList = this.dropdownTypeList;

      console.log("userConfig", this.dropdownList);


      if (this.useIndividualMail == 1 && this.dropdownList && this.dropdownList.length > 0) {
        this.firstFormGroup.patchValue({
          fromEmailId: this.dropdownList[0].userMailConfigId,
          fromEmail: this.dropdownList[0].emailAddress,
        });
      } else {
        this.firstFormGroup.patchValue({
          fromEmailId: '',
          fromEmail: '',
        });
      }

    },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['emailAddress'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  onFromEmailChange(userMailConfigId: any) {
    if (!this.dropdownTypeList) {
      return;
    }
    const selected = this.dropdownTypeList.find(opt => opt.userMailConfigId === userMailConfigId);
    if (selected) {
      this.firstFormGroup.patchValue({
        fromEmail: selected.emailAddress,
      });
    }
  }

  goToMailConfig() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/userMailConfig']);
    });
  }

}



